import * as types from './mutation-types'

export default {
    initstorage({ commit }) {
        commit('initializestate')
    },
    chg_acounts({ commit }, value) {
        commit(types.ACOUNTS, value)
    },
    setGameclass({ commit }, value) {
        commit(types.SET_GAMEID, value)
    }
}